import { render, staticRenderFns } from "./CRMLawcaseFilelist.vue?vue&type=template&id=86560056&scoped=true&"
import script from "./CRMLawcaseFilelist.vue?vue&type=script&lang=js&"
export * from "./CRMLawcaseFilelist.vue?vue&type=script&lang=js&"
import style0 from "./CRMLawcaseFilelist.vue?vue&type=style&index=0&id=86560056&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86560056",
  null
  
)

export default component.exports